// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"I1-z","dimensionLabel":"J1-z","styleChooserControlWrapper":"K1-z","styleChooserControl":"L1-z","disabled":"M1-z","giftCard":"N1-z","styleChooserText":"O1-z"};